import { render, staticRenderFns } from "./Ending.vue?vue&type=template&id=544c5691&scoped=true&lang=pug&"
import script from "./Ending.vue?vue&type=script&lang=js&"
export * from "./Ending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544c5691",
  null
  
)

export default component.exports